import {ListQueryType} from "./list";
import {SearchCondition} from "./page";

export enum OrganShareFilterWordType{
    MANAGER_NAME = "MANAGER_NAME", // 이름
    ID = "ID", // EMAIL
    CELL_PHONE = "CELL_PHONE", // 휴대전화
    ORGAN_NAME = "ORGAN_NAME", // 소속명
}

// 소속 공유 검색 DTO
export interface OrganShareListQueryType extends ListQueryType {
    searchWordType?: string;
    searchWord?: string;
}

export interface OrganShareSearchCondition extends SearchCondition {
    query?: string;
    query_type?: string;
}

export interface OrganShareDTO {
    idx: number,
    organIdx: number,
    organName: String,
    organManagerName: String,
    organManagerIdx: number,
    organManagerEmail: String,
    organManagerPhoneNumber: String,
    organManagerCodePhone: String,
}

// ㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡ 리스트 완료

export enum OrganManagerShareFilterWordType{
    MANAGER_NAME = "MANAGER_NAME", // 이름
    MANAGER_ID = "MANAGER_ID", // email
    CELL_PHONE = "CELL_PHONE", // 휴대전화
}

export enum OrganManagerType {
    ROLE_ORGAN_MANAGER = "ROLE_ORGAN_MANAGER",
    ROLE_ORGAN_MANAGER_SHARE = "ROLE_ORGAN_MANAGER_SHARE",
    ROLE_ORGAN_MANAGER_SHAREE = "ROLE_ORGAN_MANAGER_SHAREE"
}

// 읽기 권한 부여 검색 DTO
export interface OrganManagerShareListQueryType extends ListQueryType {
    searchWordType?: string;
    searchWord?: string;
}

export interface OrganManagerShareDTO {
    idx: number,
    managerName: string,
    email: String,
    phoneNumber: String,
    codePhone: String,
}

// 소속 권한 부여 DTO
export interface OrganShareAllocateDTO {
    organList: number[];
    organManagerList: number[]
}

export interface OrganShareDeallocateDTO {
    organList: number[];
}